import { useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'
import type { RewardOverviewData } from './RewardOverview'
import { RewardOverview } from './RewardOverview'

type Props = {
  rewards: RewardOverviewData[]
}

export function RewardList({ rewards }: Props) {
  const { gen } = useCampaignSlug()

  if (rewards.length === 0) {
    return <p className="p-4 text-center text-gray-400">特典が見つかりません</p>
  }

  return (
    <ul className="divide-y divide-gray-100">
      {rewards.map((reward) => (
        <li key={reward.id}>
          <RewardOverview reward={reward} href={gen(`/rewards/detail?id=${reward.id}`)} />
        </li>
      ))}
    </ul>
  )
}
